import Axios from 'axios';
import {
  documentQuery,
  documentTrackingQuery,
  loadDocumentPageQuery,
  documentPreviewTokenQuery,
  pageThumbUrl,
} from '@/api/documents/graphql/document.queries';
import { IDocumentTracking } from '@/document-tracking/types/document-tracking';
import { apolloClient } from '@/apollo';
import { correctDates } from '@/dealroom/services/dealroom.service';
import { IDocument } from '@/types/Document';
import { IDocumentPage } from '@/types/document-page';
import { ISession } from '@/types/Session';
import { IPreviewToken } from '@/dealroom/document/types/preview-token';

export class DocumentService {
  static async loadDocument(documentId: string): Promise<IDocument> {
    const {
      data: { document },
    } = await apolloClient.query({
      query: documentQuery,
      variables: { documentId },
      fetchPolicy: 'network-only',
    });
    return correctDates(document);
  }

  static async loadDocumentPage(documentId: string, id: string): Promise<IDocumentPage> {
    const {
      data: { documentPage },
    } = await apolloClient.query({
      query: loadDocumentPageQuery,
      variables: { documentId, id },
      fetchPolicy: 'network-only',
    });
    return documentPage;
  }

  static async loadPageThumbUrl(
    documentPageId: string,
    documentId: string
  ): Promise<Partial<IDocumentPage>> {
    const {
      data: { documentPage },
    } = await apolloClient.query({
      query: pageThumbUrl,
      variables: { id: documentPageId, documentId },
      fetchPolicy: 'cache-first',
    });
    return documentPage;
  }

  static async createSampleDocument(session: ISession): Promise<string> {
    const payload = new FormData();
    const templateId: string = '8qgr7u3vykx';
    payload.append('document-id', templateId);
    const {
      data: { document_id },
    } = await Axios.post('/get/sample/document', payload);
    if (!session) {
      return;
    }
    if (document_id) {
      const body = new FormData();
      body.append('action', 'save');
      body.append('document-id', document_id);
      body.append('recipient-email', session.email || '');
      body.append('recipient-first_name', session.first_name || '');
      body.append('recipient-last_name', session.last_name || '');
      body.append('recipient-role', 'signer');
      await Axios.post('/save/recipient', body);
    }

    return document_id;
  }

  static async loadTracking(documentId: string): Promise<IDocumentTracking> {
    const {
      data: { document },
    } = await apolloClient.query({
      query: documentTrackingQuery,
      variables: { documentId },
      fetchPolicy: 'no-cache',
    });
    return document;
  }

  static async getPreviewToken(documentId: string): Promise<IPreviewToken> {
    const {
      data: { previewToken },
    } = await apolloClient.query({
      query: documentPreviewTokenQuery,
      variables: { documentId },
      fetchPolicy: 'no-cache',
    });
    return previewToken;
  }
}
